import { POSTING_CATEGORIES } from "@/lib/constants";

const fmtPeriod = (per) => (per && per.length >= 7 ? `${per.slice(5, 7)}/${per.slice(0, 4)}` : "");

// Ratenzahlungs-Buchungen: nach außen „Ratenzahlung · Rate 2/6“, intern echte Kategorie
export default function PostingCategoryLabel({ p, className = "" }) {
  const cat = POSTING_CATEGORIES[p.category] || p.category;
  if (!p.linked_installment_plan_id) return <span className={className}>{cat}</span>;
  const rate = `Rate ${p.linked_installment_index}${p.linked_installment_total ? `/${p.linked_installment_total}` : ""}`;
  return (
    <span className={`inline-flex flex-col leading-tight ${className}`} data-testid={`posting-installment-label-${p.id}`}>
      <span>Ratenzahlung · {rate}</span>
      <span className="text-[10px] font-normal text-slate-400" data-testid={`posting-installment-intern-${p.id}`}>
        intern: {cat}{p.period ? ` ${fmtPeriod(p.period)}` : ""}
      </span>
    </span>
  );
}
